<template>
  <div class="form-group bg-light-2 p-4 shadow-lg mt-5">
    <div class="container-form-treid">
      <h4 class="d-inline mr-1">Detalles del {{ kind }}</h4>
      <h5 class="d-inline">(Solo se pueden publicar {{ kind }}s nuevos)</h5>
      <hr />
      <label> <span class="text-danger">*</span> Título del {{ kind }} </label>
      <input
        type="text"
        class="form-control"
        placeholder="Samsung galaxy S5"
        :value="name"
        @change="handleChangeName"
      />
      <label class="mt-5">Descripción del {{ kind }}</label>
      <textarea
        type="text"
        class="form-control"
        :placeholder="`Descripción del ${kind}`"
        rows="6"
        :value="description"
        @change="handleChangeDescription"
      />
      <label class="mt-5">
        <span class="text-danger">*</span> Categoría del {{ kind }}
      </label>
      <div class="row">
        <div class="col-12">
          <select class="form-control" @change="handleChangeCategory">
            <option value="0" :selected="categorySelected == '0'">
              Selecciona una categoria
            </option>
            <option
              v-for="_category in categories"
              :key="_category._id"
              :value="_category._id"
              :selected="categorySelected == _category._id"
            >
              {{ _category.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../tools/Api2";
export default {
  name: "DetailPublication",
  props: {
    kind: {
      type: String,
      default: "producto",
    },
    name: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    categorySelected: {
      type: String,
      default: "0",
    },
  },
  data(){
    return{
      categories: []
    }
  },
  created: function () {
    Api("category?filter[kind]="+this.kind)
      .get()
      .then((res) => {
        this.categories = res.categories;
      });
  },
  methods: {
    handleChangeName(e) {
      this.$emit("handleChangeName", e.target.value);
    },
    handleChangeDescription(e) {
      this.$emit("handleChangeDescription", e.target.value);
    },
    handleChangeCategory(e) {
      const newCategory = this.categories.find((category) => category._id == e.target.value);
      this.$emit("handleChangeCategory", {
        _id: newCategory._id,
        name: newCategory.name,
        crr: newCategory.crr,
      });
    },
  },
};
</script>